module.exports = __webpack_public_path__ + "static/img/xyfu.2d415138.jpg";